import React, { useState } from 'react'
import { StyleSheet, ScrollView, Dimensions, View, TouchableOpacity, TouchableWithoutFeedback, Platform } from 'react-native'
import { useRoute } from '@react-navigation/native';
import {
  StoredPaymentMethod,
  ProductListItem,
  Button,
  Space,
  ErrorMessage,
  ReturnFooter,
  Text,
  Switch
} from '@sart/components'
import { useContent } from '@sart/content'
import client, { useClient } from '@sart/client'
import { adaptive, colors, typography } from '@sart/styles'
import { prettyErrorMessage, testID } from '@sart/utilities'

export default function Checkout(props) {
  const { navigation, route } = props
  const currentRoute = useRoute();
  const product = route.params?.product
  const currentPlan = route.params?.currentPlan
  // let paymentMethod = navigation.getParam('paymentMethod')
  const from = route.params?.from !== undefined ? route.params.from : currentRoute.name

  const [{ loading, error }, setData] = useState({ loading: false, error: '' })
  const [receiptNeeded, setReceiptNeeded] = useState(false)
  const [recurring, setRecurring] = useState(false)
	const [apiLoading, setApiLoading] = useState(false)
  const {
    cache: {
      basket,
      storedPayment,
      cachedPayment,
      customer,
      accounts,
			language
    } = {}
  } = useClient()
  const [activePurchase, setActivePurchase] = useState(true)
  let paymentMethod

  const basketTotal = basket && basket.serviceItems && basket.serviceItems.length > 0 ? (basket.total / 100).toFixed(2) : 0

  if (cachedPayment !== undefined) {
    paymentMethod = cachedPayment
  } else if (paymentMethod === undefined && storedPayment !== undefined) {
    paymentMethod = storedPayment
    paymentMethod.method = 'storedDetails'
  } else {
    paymentMethod = route.params?.paymentMethod
  }

  const content = useContent()

  const failedOrder = route.params?.failedOrder


  React.useEffect(() => {
    if (cachedPayment !== undefined) {
      paymentMethod = cachedPayment
    }
    else if (paymentMethod === undefined && storedPayment !== undefined) {
      paymentMethod = storedPayment
      paymentMethod.method = 'storedDetails'
    }
    client.setCache({ basket })
  }, [basket, cachedPayment])

  React.useEffect(() => {
    if (failedOrder && failedOrder.paymentFailed) {
      setData({ error: content.errors.paymentFailed })
    } else if (failedOrder) {
      setData({ error: content.errors.failedPurchase })
    }
  }, [failedOrder])
  const spaceHeight = Dimensions.get('window').height > 700 ? 24 : 12

  function handleChoosePayment() {
    navigation.navigate('Payment', {
      from,
      product,
      paymentMethod
    })
  }

  // function getBasketQuantity() {
  //   for(var i = 0; i < basket.length; i++) {
  //     basketQuantity === basket[i].quantity
  //   }
  // }

  function changeRFC() {
    navigation.navigate('Receipt')
  }

  async function addProduct(product) {
    //get the product from the cache
    for (var i = 0; i < basket.length; i++) {
      if (product === basket[i]) {
        basket[i].quantity = basket[i].quantity + 1
      }
    }
    client.setCache({ basket })
  }

  async function removeProduct(product) {
    //remove either one of the quantity, or remove the whole product if the quantity is 1
    for (var i = 0; i < basket.serviceItems.length; i++) {
      if (product === basket.serviceItems[i]) {
        if (basket.serviceItems[i].quantity === 1) {
          basket.serviceItems.splice(i, 1)
        } else {
          basket.serviceItems[i].quantity = basket.serviceItems[i].quantity - 1
        }
      }
    }
    client.setCache({ basket })
  }

  async function removeAllOfProduct(product) {
    // console.log(product);
    for (var i = 0; i < basket.serviceItems.length; i++) {
      if (product === basket.serviceItems[i]) {
        basket.serviceItems.splice(i, 1)
      }
    }
    client.setCache({ basket })
  }

  async function handlePurchase() {
    setActivePurchase(false)
    setData({ loading: true, error: '' })

    try {
      var shoppingBasket = basket

      if (currentPlan) {
        shoppingBasket = await basketHelper.addDeleteServiceProductToBasket(shoppingBasket, currentPlan)
      }
      var productsPurchased = []
      for (var i = 0; i < basket.serviceItems.length; i++) {
        var product = Object.assign({}, basket.serviceItems[i])
				var fullProduct = await client.callApi('catalog','getProduct',[client.cache.catalogId, product.productId])
        fullProduct.quantity = 1
        productsPurchased.push(fullProduct)
        var extendedData = {}
        extendedData.receiptRequired = false
        extendedData.agentReferalCode = ""
        if (receiptNeeded) {
          extendedData = {}
          extendedData.receiptRequired = true
          product.extendedData = extendedData
        }

        for (var j = 0; j < basket.serviceItems[i].quantity; j++) {
          shoppingBasket = await client.addServiceProductToBasket(
            shoppingBasket,
            product,
            extendedData
          )
        }
      }
      var confirmedBasket = await client.confirmBasket(shoppingBasket)
      var order

      if (paymentMethod.method === 'creditCard') {
        const { basketRefId, gatewayURL } = await client.payForBasketWithHostedPayment(confirmedBasket);
        setData({ loading: false, error: '' })
        navigation.navigate('HostedPayment', { basketRefId, gatewayURL, productsPurchased })
      } else if (paymentMethod.method === 'balance') {
        order = await client.payForBasketWithBalance(confirmedBasket)
        order = await client.pollOrderForStatus(
          client.cache.customerId,
          order.orderId
        )
        order.paymentMethod = paymentMethod.method
      } else if (paymentMethod.method === 'cash') {
        const resp = await client.payForBasketWithCash(confirmedBasket)
        const { barCode } = resp;
        navigation.navigate('ProcessingCash', { barCode, total: confirmedBasket.total })
      } else if (paymentMethod.method === 'storedDetails') {
        if (storedPayment.tokenizedCards[0]) {
          order = await client.payForBasketWithStoredCard(
            confirmedBasket,
            storedPayment.tokenizedCards[0]
          )
          order = await client.pollOrderForStatus(
            client.cache.customerId,
            order.orderId
          )
          order.paymentMethod = paymentMethod.method
        }
      }
      if (order && order.status === 'successful') {
        // await client.loadBalancesAndInvoices()
        // setData({ loading: false, error: '' })
				client.setCache({loading: true})
        await client.loadBalancesAndInvoices(accounts[0])
				client.setCache({loading: false})
        navigation.navigate('Confirmation', {
          productsPurchased,
          order
        })
      } else if (order && order.status === 'failed') {
        setData({ loading: false, error: content.errors.failedPurchase })
      }
    } catch (error) {
      // TODO: handle error
      console.log('error is: ');
      console.log(error);
      const message = prettyErrorMessage(error, 'checkout', content);
      //setData({ loading: false, error: content.errors.failedPurchase })
      console.log('message is: ');
      console.log(message);

      setData({ loading: false, error: message })
    }
    setActivePurchase(true)
  }

  return (
    <ScrollView style={styles.container}>
      <View style={styles.wrapper}>
        <Space height={12} />
        {basket !== undefined && basket.serviceItems !== undefined && basket.serviceItems.length > 0 &&
          <View>
            {basket.serviceItems.map(product => (
              <React.Fragment key={product.productId}>
                <ProductListItem
                  disabled={true}
                  product={product}
									loadingBackgroundStyle={styles.productStyle}
                  placeholderStyle={styles.productStyle}
                  priceStyle={styles.priceStyle}
                  imageColor={colors.white}
                  basket={basket}
                  allowDelete={!apiLoading}
                  removeProductFunction={() => removeAllOfProduct(product)}
									language={language}
									injectedContent={content}
                />
                {/* { product.tags.find((tag) => tag.tag === 'package') === undefined && 
                <View style={styles.quantity}>
                  <ProductQuantitySelector 
                    quantity={product.quantity}
                    decreaseProduct={() => removeProduct(product)}
                    increaseProduct={() => addProduct(product)}
                  />
                </View>
              } */}
                <Space height={12} />
              </React.Fragment>
            ))}
          </View>
        }
        <Text style={styles.cardLabel}>{content.storedPayment.title}</Text>
        <StoredPaymentMethod
          editable
          disabled={loading}
          payment={paymentMethod}
          onEditPayment={handleChoosePayment}
          containerStyle={styles.storedPaymentContainer}
          style={styles.inputStyle}
          footerStyle={styles.footerStyle}
					language={language}
					injectedContent={content}
          {...testID('ChoosePayment')}
        />
        <Space height={spaceHeight} />
        {(basket && basket.serviceItems && basket.serviceItems.length > 0) &&
          [<Space height={12} />,
          <View style={styles.totalContainer}>
            {/* <Space height={10}/> */}
            <Text style={styles.textTotal}>
              {content.checkout.total} £{basketTotal}
            </Text>
          </View>
          ]
        }
        {/* </View> */}
        <Space height={spaceHeight} />

        {(error !== '') &&
          <View>
            <ErrorMessage key={0}>{error}</ErrorMessage>
            <Space height={spaceHeight} key={1} />
          </View>
        }
        <Button
          title={
            loading
              ? content.add_on_checkout.submitting
              : content.add_on_checkout.submit
          }
          onPress={handlePurchase}
          disabled={(loading || apiLoading || (basket && basket.serviceItems && basket.serviceItems.length === 0) || !paymentMethod)}
          style={styles.enabled}
          disabledStyle={styles.disabled}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45,
          }}
          {...testID('CheckoutPurchaseButton')}
        />
        {/* {activePurchase && */}
        <ReturnFooter
          disabled={!activePurchase}
          title={content.common.cancel}
          onPress={() => activePurchase ? navigation.goBack() : {}}
        />
        {/* } */}

      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
		backgroundColor:colors.white,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    paddingBottom: 24
  },
  addOnDescription: {
    color: colors.common,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: 24
  },
  basket: {
    marginTop: 10,
    marginBottom: 10
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: 0,
    padding: 0
  },
  items: {
    margin: 5
  },
  total: {
    margin: 5
  },
  priceStyle: {
    color: colors.srTextInput
  },
  productStyle: {
    backgroundColor: colors.srGreen
  },
  receiptContainer: {
    ...Platform.select({
      android: { flexDirection: 'row' },
      ios: { flexDirection: 'row' }
    }),
    // flexDirection:'column',
    width: '100%',
    alignItems: 'center',
    alignSelf: 'center'
  },
  checkBoxContainer: {
    width: '20%',
  },
  rfcNumber: {
    // marginLeft:5,
    // width: '50%'
  },
  button: {
    backgroundColor: colors.srGreyBackground
  },
  buttonDisabled: {
    backgroundColor: colors.srGreyBackground + 54
  },
  quantity: {
    justifyContent: 'flex-end'
  },
  checkboxView: {
    ...Platform.select({
      android: {
        padding: 0
      },
      ios: {
        padding: 0
      }
    }
    )
  },
  containerStyle: {
    padding: 0,
  },
  recieptLabelStyle: {
    paddingRight: 5,
    ...typography.lightbold
  },
  storedPaymentChoose: {
    fontSize: 15,
    color: colors.trivial,
    marginTop: 8,
    ...typography.medium
  },
  totalContainer: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    // paddingLeft: '35%'
  },
  textTotal: {
    color: colors.srGreen,
    ...typography.lightbold,
    fontSize: 20,
    // alignSelf: 'center'
  },

  lineStyle: {
    width: '40%',
  },
  cardLabel: {
    color: colors.srGreen,
    ...typography.demi
  },
  // viewStyle: {
  //   flexDirection: 'row'
  // }
  inputStyle: {
    ...typography.book,
    paddingRight: 20,
  },
  footerStyle: {
    fontSize: 15,
    color: colors.common,
    marginTop: 8,
    ...typography.medium
  },
  enabled: {
    backgroundColor: colors.srDarkGreen
  },
  disabled: {
    backgroundColor: colors.srDarkGreen + 60,
    borderColor: colors.srGreen,
    borderWidth: 1
  },
  storedPaymentContainer: {
    backgroundColor: colors.white,
    borderColor: colors.srGreen,
    borderWidth: 1
  },
  headerText: {
    ...typography.lightbold,
    fontSize: 16
  },
  saveCardContainer: {
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    padding: 5
  },
  saveCardTextContainer: {
    flexDirection: 'column', 
    width: '70%'
  }
}
)
